// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","textShadow":"Footer_textShadow__zf53E","glitch1":"Footer_glitch1__YGnOx","Box":"Footer_Box__3FiRx"};